export default __webpack_public_path__ + "img/instra5.100bcaff.jpg";